var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRssFeedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm9.333-8h-3.301c0-7.737-6.295-14.032-14.032-14.032V6.667c9.557 0 17.333 7.775 17.333 17.333zm-14.857 0a2.476 2.476 0 100-4.952 2.476 2.476 0 000 4.952zm5.778 0h3.302c0-6.372-5.184-11.556-11.556-11.556v3.302c4.551 0 8.254 3.703 8.254 8.254z",
    fill: "#fff"
  })));
}
export default SvgRssFeedIcon;